import React from "react";
import { Table } from "antd";
import "../dell.css"; // Import the same CSS file used in ParticipantTable

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Remaining Evaluations",
    dataIndex: "remainingAssignments",
    key: "remainingAssignments",
    sorter: (a, b) => a.remainingAssignments - b.remainingAssignments,
    sortDirections: ["ascend", "descend"], // Add sortDirections property
  },
  {
    title: "Total Evaluations",
    dataIndex: "totalAssigned",
    key: "totalAssigned",
    sorter: (a, b) => a.totalAssigned - b.totalAssigned,
    sortDirections: ["ascend", "descend"], // Add sortDirections property
  },
];

const JudgeTable = ({ judges }) => {
  const rowClassName = () => {
    return "white-row"; // Custom class for rows with white background, if needed
  };

  return (
    <div className="participant-table-container">
      {" "}
      {/* Reuse the same container class */}
      <Table
        dataSource={judges} // Pass the judges data as dataSource
        columns={columns}
        className="dell-table" // Reuse the same table class
        rowClassName={rowClassName} // Apply custom class to rows if needed
      />
    </div>
  );
};

export default JudgeTable;
